/* (21 Oct) Homepage film with sound, and the header music. Only one plays at a time:
   - the film's sound turns on with the visitor's first tap / click / key press (browsers block sound before that),
     unless the header music is playing
   - header music on: the film pauses. Film played or unmuted: the music pauses
   - pausing and playing the film again keeps the sound as the visitor left it */
(function () {
  var music = function () { return document.querySelectorAll('audio.sm-track, audio[data-sm-track], #sm-ambient'); };
  var musicOn = function () { return Array.prototype.some.call(music(), function (a) { return !a.paused; }); };
  var film = function () { return document.querySelector('[data-sm-film] video, .shopify-section--video video'); };
  var pauseMusic = function () { music().forEach(function (a) { if (!a.paused) a.pause(); }); };
  var userAct = function () { return !navigator.userActivation || navigator.userActivation.isActive; };

  /* first interaction on the page: film sound on */
  var events = ['click', 'touchend', 'keydown'];
  var stop = function () { events.forEach(function (ev) { document.removeEventListener(ev, first, true); }); };
  var first = function (e) {
    var v = film();
    if (!v) { stop(); return; }
    var t = e.target;
    /* the header sound button and the film's own controls decide for themselves */
    if (t === v || (t.closest && t.closest('#sm-sound-btn, [data-sm-sound], [data-sm-play], [data-sm-player], .sm-video-sound, [onclick*="SmelodySound"]'))) { stop(); return; }
    stop();
    if (musicOn() || (v.paused && v.dataset.smStarted)) return;
    v.muted = false;
  };
  if (film() || document.querySelector('template[data-sm-video]')) events.forEach(function (ev) { document.addEventListener(ev, first, true); });

  /* on load: if this browser already allows sound (e.g. Chrome for repeat visitors), turn the film's sound on.
     Checked with a silent sound, so the film itself is never interrupted (Safari stops a film that is unmuted too early) */
  var probeSound = function () {
    var v = film();
    if (!v || musicOn()) return;
    try {
      var probe = new Audio('data:audio/wav;base64,UklGRlQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YTAAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIA=');
      var p = probe.play();
      if (p && p.then) p.then(function () {
        probe.pause();
        if (!musicOn() && !v.paused) v.muted = false;
      }).catch(function () {});
    } catch (e) {}
  };
  /* the film is added after the page has loaded (sections/video.liquid) */
  if (film()) { probeSound(); } else { document.addEventListener('sm:film-ready', function () { var f = film(); if (f) f.addEventListener('playing', probeSound, { once: true }); }); }

  /* a visitor plays the film (play button, or play after pausing): with sound, music pauses */
  document.addEventListener('play', function (e) {
    var t = e.target;
    if (t instanceof HTMLVideoElement) {
      if (t.dataset.smStarted && userAct() && t.muted && !t.dataset.smUserMuted) t.muted = false;
      if (!t.muted) pauseMusic();
      return;
    }
    /* music starts: the film pauses */
    if (t instanceof HTMLAudioElement) document.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
  }, true);

  /* film unmuted with its own control: music pauses. Muted on purpose: remember it for play/pause */
  document.addEventListener('volumechange', function (e) {
    var v = e.target;
    if (!(v instanceof HTMLVideoElement)) return;
    if (userAct()) { if (v.muted) { v.dataset.smUserMuted = '1'; } else { delete v.dataset.smUserMuted; } }
    if (!v.muted && v.volume > 0 && !v.paused) pauseMusic();
  }, true);
})();

/* (21 Oct) theme editor: when the video section is re-rendered, insert the film for this screen size */
document.addEventListener('shopify:section:load', function (e) {
  e.target.querySelectorAll('.content-over-media').forEach(function (root) {
    if (root.querySelector('video-media') || !root.querySelector('template[data-sm-video]')) return;
    var pick = window.matchMedia('(max-width: 699px)').matches ? 'mobile' : 'desktop';
    var tpl = root.querySelector('template[data-sm-video="' + pick + '"]');
    var cover = root.querySelector(':scope > picture');
    if (tpl) root.insertBefore(tpl.content.cloneNode(true), cover ? cover.nextSibling : root.firstChild);
  });
});
